import { cva } from 'class-variance-authority';

/**
 * Modal root container variants.
 */
export const modalContainerVariants = cva(
  'fixed inset-0 z-50 flex items-center justify-center p-4',
  {
    variants: {
      isOpen: {
        false: 'invisible',
        true: 'visible',
      },
    },
    defaultVariants: {
      isOpen: false,
    },
  },
);

/**
 * Backdrop overlay variants.
 */
export const modalOverlayVariants = cva(
  'absolute inset-0 bg-neutral-black transition-opacity duration-300',
  {
    variants: {
      isOpen: {
        false: 'opacity-0',
        true: 'opacity-50',
      },
    },
    defaultVariants: {
      isOpen: false,
    },
  },
);

/**
 * Modal panel variants.
 */
export const modalPanelVariants = cva(
  'relative z-10 bg-neutral-white rounded-lg shadow-xl w-full max-w-lg flex flex-col transition-all duration-300',
  {
    variants: {
      isOpen: {
        false: 'scale-95 opacity-0',
        true: 'scale-100 opacity-100',
      },
    },
    defaultVariants: {
      isOpen: false,
    },
  },
);

/**
 * Modal header variants.
 */
export const modalHeaderVariants = cva('px-8', {
  variants: {
    hasTitle: {
      false: 'pt-6 pb-2 min-h-12',
      true: 'pt-12 pb-3.5 flex items-start justify-between',
    },
  },
  defaultVariants: {
    hasTitle: true,
  },
});

/**
 * Modal title styles.
 */
export const modalTitleStyles = [
  'font-bold',
  'font-text',
  'leading-body-title',
  'text-body-title',
  'text-neutral-black',
].join(' ');

/**
 * Modal body styles.
 */
export const modalBodyStyles = ['px-8 flex flex-col gap-6'].join(' ');

/**
 * Modal footer styles.
 */
export const modalFooterStyles = ['flex items-center gap-3 px-8 pb-10 pt-6'].join(' ');

/**
 * Modal plain string body text styles.
 */
export const modalStringContentStyles = [
  'font-bold',
  'font-text',
  'leading-6',
  'text-body',
  'text-neutral-gray-800',
].join(' ');

/**
 * Modal close button styles.
 */
export const modalCloseButtonStyles = [
  'absolute right-0 top-0',
  'mx-6 my-4',
  'text-neutral-black',
].join(' ');
